export default __webpack_public_path__ + "static/Nadya Novyani-4600127ecda775bcc902fedf1458a7e8.jpeg";